export function formatClaimValue(value: unknown): string {
  if (value === undefined || value === null || value === "") {
    return "Not provided";
  }

  if (Array.isArray(value)) {
    return value.join(", ");
  }

  if (typeof value === "object") {
    return JSON.stringify(value);
  }

  return String(value);
}
